module.exports = __webpack_public_path__ + "static/media/banerSylwester(2).1c51c8a7.jpg";